import React, { useState } from 'react'
import style from './TestResult.module.scss'
import { dateFormat } from 'helpers/date'
import Stores from 'Stores'
import { NavLink } from 'react-router-dom'
import {
  EditIconButton,
  SuperButton,
} from 'components/UI/SuperButton/SuperButton'
import { ReactComponent as Delete } from 'components/UI/icons/delete-bin-6-line.svg'
import RowScore from 'components/CRM/UI/components/RowScore/RowScore'
import { ReactComponent as ArrowIcon } from 'components/UI/icons/arrow-down-s-line.svg'

const TestResult = ({ item, actions, listing, showAllTests }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  const sortedTests = item?.data?.sort(
    (a, b) =>
      new Date(b.date || b.date_until) - new Date(a.date || a.date_until),
  )

  const displayedTests = showAllTests ? sortedTests : sortedTests.slice(0, 5)

  return (
    <div
      className={`${style.testResult} ${isOpen ? style.open : ''}`}
      style={listing && { border: 'none' }}
    >
      <div className={style.header}>
        <div className={style.info}>
          {item?.student &&
            item?.student?.last_name &&
            item?.student?.first_name && (
              <NavLink
                target='_blank'
                to={'/account_clients/' + item?.student?.user_id}
              >
                {Stores.transliterate(
                  `${item?.student?.last_name} ${item?.student?.first_name}`,
                )}
              </NavLink>
            )}
        </div>
        <div
          className={`${style.toggleIcon} ${isOpen ? style.rotated : ''}`}
          onClick={toggleOpen}
        >
          <ArrowIcon />
        </div>
      </div>
      {isOpen &&
        displayedTests?.map((test, index) => {
          const isFinished =
            test?.status === 'finished' || test?.status === 'time_out'
          let percentage = 0
          const totalPoints = test?.stats?.total_points || 0
          const studentPoints = test?.total_stats?.points || 0
          percentage =
            totalPoints === 0
              ? 0
              : Math.min(100, Math.round((studentPoints / totalPoints) * 100))

          return (
            <div className={style.box} key={index}>
              <div className={style.unitAndDateAndScore}>
                <div className={style.unitAndDate}>
                  <div className={style.unitAndLvls}>
                    <div className={style.unitContainer}>
                      <div className={style.unit}>
                        {test?.test_name ? (
                          <div className={style.flex}>
                            {test?.test_name}
                            <div className={style.greyLine}></div>
                            {test?.name}
                          </div>
                        ) : (
                          <div className={style.flex}>
                            {test?.category || ''}
                            <div className={style.greyLine}></div>
                            {test?.test || ''}
                          </div>
                        )}
                      </div>
                    </div>
                    {isFinished && (
                      <div className={style.lvls}>
                        <div className={style.lvlsDescriptions}>
                          {test?.category}
                        </div>
                        <div className={style.lvlsDescriptions}>
                          {test?.sub_lvl?.lvl?.name}
                        </div>
                        <div className={style.lvlsLine}></div>
                        <div className={style.lvlsDescriptions}>
                          {test?.sub_lvl?.name}
                        </div>
                        <div className={style.lvlsLine}></div>
                        <div className={style.lvlsDescriptions}>
                          {test?.sub_lvl?.lvl?.subname}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={style.dateContainer}>
                    <div className={style.dateWord}>Date:</div>
                    <div className={style.date}>
                      {dateFormat(
                        new Date(test.date || test?.date_until),
                        'd MMM YYYY',
                      )}
                    </div>
                  </div>
                </div>
                <div className={style.scoreAndBtn}>
                  {isFinished ? (
                    <RowScore
                      correctAnswers={studentPoints}
                      percentage={percentage}
                    />
                  ) : (
                    <RowScore
                      correctAnswers={studentPoints}
                      percentage={test?.test_scores}
                      withoutScores
                    />
                  )}
                  {isFinished && (
                    <div className={style.btn}>
                      <SuperButton
                        variant={'link'}
                        type={'linkColored'}
                        path={`/study/test/${test?.test_id}`}
                      >
                        Full Results
                      </SuperButton>
                    </div>
                  )}

                  {!Stores.isClient && (
                    <div className={style.buttons}>
                      <div className={style.buttonsControl}>
                        <EditIconButton
                          onClick={(e) => actions('edit', e, test, isFinished)}
                        />
                        {!isFinished && (
                          <div
                            className={style.deleteBasket}
                            onClick={(e) => actions('delete', e, test)}
                          >
                            <Delete />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {(test?.description || test?.employee_comment) && (
                <div className={style.comments}>
                  <div>Comment:</div>
                  {test?.description && (
                    <div
                      className={style.description}
                      dangerouslySetInnerHTML={{ __html: test?.description }}
                    />
                  )}
                  {test?.employee_comment && (
                    <div
                      className={style.description}
                      dangerouslySetInnerHTML={{
                        __html: test?.employee_comment,
                      }}
                    />
                  )}
                </div>
              )}

              {index < sortedTests.length - 1 && (
                <div className={style.horizontalLine}></div>
              )}
            </div>
          )
        })}
    </div>
  )
}

export default TestResult
